import { Link } from "react-router-dom";

const COLORS = {
  bg: "#0F172A",
  ink: "#F8FAFC",
  body: "#CBD5E1",
  sub: "#94A3B8",
  line: "rgba(255, 255, 255, 0.08)",
};

export default function MobileFooter() {
  return (
    <footer style={{ background: COLORS.bg, color: COLORS.body, marginTop: 48 }}>
      <div style={{ padding: "40px 20px 28px" }}>
        {/* 브랜드 + 연락 */}
        <div style={{ display: "flex", flexDirection: "column", gap: 10, marginBottom: 28 }}>
          <div
            style={{
              fontSize: 20,
              fontWeight: 800,
              color: COLORS.ink,
              letterSpacing: "-0.02em",
            }}
          >
            뚝딱이
          </div>
          <p
            style={{
              margin: 0,
              fontSize: 13,
              lineHeight: 1.7,
              color: COLORS.body,
            }}
          >
            농기계 고장 시, 가까운 수리기사와 실시간으로 연결되는 매칭 플랫폼
          </p>
          <div style={{ display: "flex", flexDirection: "column", gap: 8, marginTop: 6 }}>
            <a
              href="mailto:misolution_design@naver.com"
              style={{
                fontSize: 13,
                color: COLORS.ink,
                textDecoration: "none",
              }}
            >
              ✉ misolution_design@naver.com
            </a>
            <a
              href="tel:07075752057"
              style={{
                fontSize: 13,
                color: COLORS.ink,
                textDecoration: "none",
                whiteSpace: "nowrap",
              }}
            >
              ☎ 070-7575-2057
            </a>
          </div>
        </div>

        {/* 메뉴 2열 */}
        <div style={{ display: "grid", gridTemplateColumns: "1fr 1fr", gap: 20, marginBottom: 28 }}>
          <FooterColumn title="서비스">
            <FooterLink to="/main">홈</FooterLink>
            <FooterLink to="/matching">요청 목록</FooterLink>
            <FooterLink to="/community">커뮤니티</FooterLink>
            <FooterLink to="/inquiry">문의하기</FooterLink>
          </FooterColumn>
          <FooterColumn title="정책">
            <FooterLink to="/terms" external>이용약관</FooterLink>
            <FooterLink to="/policy" external>개인정보처리방침</FooterLink>
          </FooterColumn>
        </div>

        <hr
          style={{
            border: "none",
            borderTop: `1px solid ${COLORS.line}`,
            margin: "0 0 20px",
          }}
        />

        {/* 사업자 정보 */}
        <div
          style={{
            display: "flex",
            flexDirection: "column",
            gap: 4,
            fontSize: 11,
            color: COLORS.sub,
            lineHeight: 1.6,
          }}
        >
          <span style={{ fontWeight: 600, color: COLORS.body, fontSize: 12 }}>
            (주)엠아이솔루션
          </span>
          <span>대표 최현 · 대전광역시 유성구 테크노1로 75, 311호</span>
          <span>사업자등록번호 393-81-02118</span>
          <span>통신판매업신고 제 2025-대전유성-0325 호</span>
        </div>

        <div
          style={{
            marginTop: 20,
            fontSize: 11,
            color: COLORS.sub,
            textAlign: "center",
          }}
        >
          © {new Date().getFullYear()} 뚝딱이. All rights reserved.
        </div>
      </div>
    </footer>
  );
}

function FooterColumn({ title, children }) {
  return (
    <div style={{ display: "flex", flexDirection: "column", gap: 10 }}>
      <div
        style={{
          fontSize: 12,
          fontWeight: 700,
          color: COLORS.ink,
          letterSpacing: "0.04em",
          textTransform: "uppercase",
        }}
      >
        {title}
      </div>
      {children}
    </div>
  );
}

function FooterLink({ to, children, external }) {
  return (
    <Link
      to={to}
      target={external ? "_blank" : undefined}
      style={{
        fontSize: 13,
        color: COLORS.body,
        textDecoration: "none",
      }}
    >
      {children}
    </Link>
  );
}
